import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../components/global/LoadingSpinner';
import { useQuery } from '@tanstack/react-query';
import { User } from 'firebase/auth';

interface SuperAdminOnlyProps {
  element: JSX.Element;
}

const fetchSuperAdminStatus = async (user: User): Promise<boolean> => {
  const token = await user.getIdTokenResult(true);
  return token.claims.superAdmin === true;
};

const SuperAdminOnlyRoute: React.FC<SuperAdminOnlyProps> = ({ element }) => {
  const { user, loading } = useAuth();

  const superAdminQuery = useQuery({
    queryKey: ['superAdminStatus'],
    queryFn: () => {
      if (user) {
        return fetchSuperAdminStatus(user)
      }
    },
    enabled: !!user,
  });

  if (loading || superAdminQuery.isLoading) {
    return <LoadingSpinner />;
  }

  if (!user || !superAdminQuery.data) {
    return <Navigate to="/admin" replace />;
  }

  return element;
};

export default SuperAdminOnlyRoute;
